(function () {
  if (window.SalomonInfiniteScroll) return;

  function createStatusNode(type, text) {
    var el = document.createElement('div');
    el.className = 'infinite-scroll-status infinite-scroll-status--' + type;
    el.style.cssText = 'display:flex;justify-content:center;align-items:center;padding:20px 0;width:100%;font-size:13px;color:rgba(var(--text-color),0.75);';
    el.textContent = text;
    return el;
  }

  function createSpinnerNode() {
    var el = document.createElement('div');
    el.className = 'infinite-scroll-status infinite-scroll-status--loading';
    el.style.cssText = 'display:flex;justify-content:center;align-items:center;padding:32px 0;width:100%;';
    el.innerHTML =
      '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" style="animation:is-spin 0.8s linear infinite">' +
        '<circle cx="18" cy="18" r="14" stroke="currentColor" stroke-width="3" stroke-dasharray="70" stroke-dashoffset="20" stroke-linecap="round"/>' +
      '</svg>' +
      '<style>@keyframes is-spin{to{transform:rotate(360deg)}}</style>';
    return el;
  }

  function removeStatusNode(state) {
    if (state.statusNode && state.statusNode.parentNode) {
      state.statusNode.remove();
    }
    state.statusNode = null;
  }

  function showStatus(state, type, text) {
    removeStatusNode(state);

    if (type === 'loading') {
      state.statusNode = createSpinnerNode();
    } else {
      state.statusNode = createStatusNode(type, text);
    }

    state.productList.parentElement.insertAdjacentElement('afterend', state.statusNode);
  }

  function getNextUrl(paginationEl) {
    var next = paginationEl.querySelector(
      'a[rel="next"], a.pagination__next, a.next, .pagination__item--next a, li.next a'
    );
    return next ? next.href : null;
  }

  function unhideRevealElements(rootNode) {
    if (!rootNode || rootNode.nodeType !== 1) return;

    if (rootNode.hasAttribute('reveal')) {
      rootNode.removeAttribute('reveal');
    }

    if (rootNode.hasAttribute('reveal-visibility')) {
      rootNode.removeAttribute('reveal-visibility');
    }

    rootNode.style.opacity = '1';
    rootNode.style.visibility = 'visible';

    rootNode.querySelectorAll('[reveal], [reveal-visibility]').forEach(function (el) {
      el.removeAttribute('reveal');
      el.removeAttribute('reveal-visibility');
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    });
  }

  function createController(config) {
    var activeState = null;
    var rebindObserver = null;

    function disconnectActiveState() {
      if (!activeState) return;
      if (activeState.observer) activeState.observer.disconnect();
      if (activeState.sentinel && activeState.sentinel.parentNode) {
        activeState.sentinel.remove();
      }
      removeStatusNode(activeState);
      activeState = null;
    }

    function finishLoadingState(state) {
      state.isLoading = false;
      state.productList.setAttribute('aria-busy', 'false');
      removeStatusNode(state);
    }

    function loadMore(state) {
      if (state !== activeState || state.isLoading || state.allLoaded) return;

      var nextUrl = getNextUrl(state.paginationEl);
      if (!nextUrl) {
        state.allLoaded = true;
        showStatus(state, 'end', config.endMessage || 'You have reached the end of the results.');
        return;
      }

      state.isLoading = true;
      state.productList.setAttribute('aria-busy', 'true');
      showStatus(state, 'loading');

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          if (state !== activeState) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.querySelector(config.productListSelector);

          if (newItems) {
            Array.from(newItems.children).forEach(function (card) {
              unhideRevealElements(card);
              state.productList.appendChild(card);
            });

            if (typeof config.onItemsAppended === 'function') {
              config.onItemsAppended(state.productList);
            }
          }

          var newPagination = doc.querySelector(config.paginationSelector);
          if (newPagination) {
            state.paginationEl.innerHTML = newPagination.innerHTML;
          } else {
            state.paginationEl.innerHTML = '';
            state.allLoaded = true;
            showStatus(state, 'end', config.endMessage || 'You have reached the end of the results.');
          }
        })
        .catch(function () {
          if (state !== activeState) return;
          showStatus(state, 'error', config.errorMessage || 'Could not load more results. Please scroll to retry.');
        })
        .finally(function () {
          if (state !== activeState) return;
          finishLoadingState(state);
        });
    }

    function bindInfiniteScroll() {
      var scope = config.scopeSelector ? document.querySelector(config.scopeSelector) : document;
      if (!scope) {
        disconnectActiveState();
        return;
      }

      var productList = scope.querySelector(config.productListSelector);
      var paginationEl = scope.querySelector(config.paginationSelector);

      if (!productList || !paginationEl) {
        disconnectActiveState();
        return;
      }

      if (activeState && activeState.productList === productList && activeState.paginationEl === paginationEl) {
        return;
      }

      disconnectActiveState();

      if (!window.IntersectionObserver) {
        paginationEl.style.display = '';
        return;
      }

      var state = {
        productList: productList,
        paginationEl: paginationEl,
        sentinel: document.createElement('div'),
        observer: null,
        isLoading: false,
        allLoaded: false,
        statusNode: null
      };

      state.sentinel.style.cssText = 'height:1px;width:100%;';
      state.paginationEl.insertAdjacentElement('beforebegin', state.sentinel);

      state.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore(state);
      }, { rootMargin: config.rootMargin || '0px 0px 300px 0px' });

      state.observer.observe(state.sentinel);
      state.paginationEl.style.display = 'none';
      activeState = state;
    }

    bindInfiniteScroll();

    if (config.observeRootSelector && window.MutationObserver) {
      var observeRoot = document.querySelector(config.observeRootSelector);

      if (observeRoot) {
        rebindObserver = new MutationObserver(function () {
          bindInfiniteScroll();
        });

        rebindObserver.observe(observeRoot, { childList: true, subtree: true });
      }
    }

    return {
      rebind: bindInfiniteScroll,
      destroy: function () {
        disconnectActiveState();
        if (rebindObserver) {
          rebindObserver.disconnect();
          rebindObserver = null;
        }
      }
    };
  }

  window.SalomonInfiniteScroll = {
    init: function (config) {
      return createController(config || {});
    }
  };

  document.dispatchEvent(new CustomEvent('salomon:infinite-scroll:ready'));
})();
